// @flow

import {
    CONFERENCE_JOINED,
    CONFERENCE_LEFT,
    getCurrentConference
} from '../base/conference';
import {
    MHConferenceEvents
} from '../base/lib-meet-hour';
import { MiddlewareRegistry, StateListenerRegistry } from '../base/redux';
import { showNotification } from '../notifications';

import { ADD_CANDP_URL, REMOVE_CANDP_URL } from './actionTypes';
import { receiveClickandPledgeURl, removeClickandPledgeUrl, removeMobileClickandPledgeURl } from './actions';


/**
 * Implements the middleware of the Donorbox  feature.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const { getState } = store;
    const state = getState();
    const conference = getCurrentConference(state);

    switch (action.type) {
    case CONFERENCE_LEFT: {
        const { dispatch } = store;

        dispatch(removeMobileClickandPledgeURl());
        break;
    }

    case CONFERENCE_JOINED:
        _addUrlMsgConference(action.conference, store);
        break;

    case ADD_CANDP_URL:
        _addDonorUrl(action, conference);
        break;

    case REMOVE_CANDP_URL: {
        const { dispatch } = store;

        _removeDonorUrl(conference);
        dispatch(showNotification({ descriptionKey: 'dialog.removeCDonationD',
            titleKey: 'dialog.removeCDonation' }, 5000));

        break;
    }


    }

    return next(action);
});


/**
 * Registers listener for {@link MHConferenceEvents.DONORBOX_URL_RECEIVED} that
 * will perform various Url related activities.
 *
 * @param {MHConference} conference - The conference instance on which the
 * new event listener will be registered.
 * @param {Object} store - The redux store object.
 * @private
 * @returns {void}
 */
function _addUrlMsgConference(conference, store) {
    const { dispatch, getState } = store;
    const state = getState();
    const { getCUrl } = state['features/clickandpledge'];

    conference.on(
        MHConferenceEvents.DONORBOX_URL_RECEIVED,
        (id, donorUrl) => {
            if (donorUrl !== undefined && donorUrl !== 'remove' && getCUrl === undefined) {
                dispatch(receiveClickandPledgeURl(donorUrl));
                dispatch(showNotification({ descriptionKey: 'dialog.donationNotificationDescription',
                    titleKey: 'dialog.donationCNotificationTitle' }, 5000));
            } else if (donorUrl !== undefined && donorUrl === 'remove') {

                dispatch(removeClickandPledgeUrl());

            }
        }
    );

}

/**
 * Sends Add DonorBox command.
 *
 * @param {Function} action - The Url of the Box.
 * @param {MHConference} conference - The current conference.
 * @param {Object} state - The State of the Conference.
 * @param {string} time - The seek position of the video.
 * @returns {void}
 */
function _addDonorUrl(action, conference) {

    conference.sendCommand(ADD_CANDP_URL, {
        value: action.addCUrl
    });
}

/**
 * Set up state change listener to perform maintenance tasks when the conference
 * is left or failed, e.g. Clear messages or close the chat modal if it's left
 * open.
 */
StateListenerRegistry.register(
    state => getCurrentConference(state),
    (conference, store, previousConference) => {
        if (conference && conference !== previousConference) {
            conference.addCommandListener(ADD_CANDP_URL,
                ({ value }) => {
                    const { dispatch, getState } = store;
                    const state = getState();
                    const { getCUrl } = state['features/clickandpledge'];

                    if (value !== undefined && value !== 'remove' && getCUrl === undefined) {
                        dispatch(receiveClickandPledgeURl(value));
                        dispatch(showNotification({ descriptionKey: 'dialog.donationNotificationDescription',
                            titleKey: 'dialog.donationCNotificationTitle' }, 5000));
                    } else if (value !== undefined && value === 'remove' && getCUrl !== undefined) {

                        dispatch(removeClickandPledgeUrl());

                    }
                }
            );
        }
    });


/**
 * Sends DonorBox Remove command.
 *
 * @param {MHConference} conference - The current conference.
 * @param {Object} state - The State of the Conference.
 * @returns {Function} Function.
 */
function _removeDonorUrl(conference) {
    conference.removeCommand(ADD_CANDP_URL);
}


